export const GET_TAX_CONTEXT_FETCHING = 'GET_TAX_CONTEXT_FETCHING';
export const GET_TAX_CONTEXT_FETCH = 'GET_TAX_CONTEXT_FETCH';
export const GET_TAX_CONTEXT_FETCH_ERROR = 'GET_TAX_CONTEXT_FETCH_ERROR';
export const RESET_TAX_CONTEXT = 'RESET_TAX_CONTEXT';
